import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Data04 = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path
        d="M7.99998 11.6001V7.6001M13.12 11.8401C12.413 11.8401 11.84 12.4132 11.84 13.1201C11.84 13.827 12.413 14.4001 13.12 14.4001C13.8269 14.4001 14.4 13.827 14.4 13.1201C14.4 12.4132 13.8269 11.8401 13.12 11.8401ZM13.12 11.8401L13.12 8.1601C13.12 7.80663 12.8334 7.5201 12.48 7.5201H3.51998C3.16651 7.5201 2.87998 7.80663 2.87998 8.1601L2.87997 11.8401M2.87997 11.8401C2.17305 11.8401 1.59998 12.4132 1.59998 13.1201C1.59998 13.827 2.17305 14.4001 2.87997 14.4001C3.5869 14.4001 4.15997 13.827 4.15997 13.1201C4.15997 12.4132 3.5869 11.8401 2.87997 11.8401ZM7.99997 14.4001C7.29305 14.4001 6.71997 13.827 6.71997 13.1201C6.71997 12.4132 7.29305 11.8401 7.99997 11.8401C8.7069 11.8401 9.27997 12.4132 9.27997 13.1201C9.27997 13.827 8.7069 14.4001 7.99997 14.4001ZM3.99998 4.8001H12C12.4418 4.8001 12.8 4.44192 12.8 4.0001V2.4001C12.8 1.95827 12.4418 1.6001 12 1.6001H3.99998C3.55815 1.6001 3.19998 1.95827 3.19998 2.4001V4.0001C3.19998 4.44192 3.55815 4.8001 3.99998 4.8001Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
})

export default Data04
